<template>
  <v-row>
    <v-col cols="2" offset="2">
      <v-btn v-if="finished" color="success" block @click="goToResults">Przejdź do wyników</v-btn>
      <v-btn v-else block @click="back">Wróć do listy szkoleń</v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    finished: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    back() {
      this.$router.push('/home/courses');
    },
    goToResults() {
      this.$router.push('/home/finished-courses');
    }
  }
};
</script>
